const Config = {
  //Environment detection
  STAGE: process.env.REACT_APP_STAGE || 'dev',
  
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  accessToken:null,

  token:null,

  practice:null,

  // Environment helpers
  get IS_PRODUCTION() {
    return this.STAGE === 'prod';
  },
  
  get IS_DEVELOPMENT() {
    return this.STAGE === 'dev';
  },
  
  get IS_STAGING() {
    return this.STAGE === 'staging';
  },

  // Configuration validation
  validate() {
    const required = ['API_BASE_URL'];
    const missing = required.filter(key => !this[key]);
    
    if (missing.length > 0) {
      console.error('Missing required environment variables:', missing);
      return false;
    }
    
    // Warn about HTTP in production
    if (this.IS_PRODUCTION && this.REDIRECT_URI?.startsWith('http://')) {
      console.warn('Production should use HTTPS for redirect URI');
    }
    
    return true;
  }
};

// Validate on module load
Config.validate();

export default Config;